<div class="container">
    <div *ngIf="loadProducts" id="loadingPage"></div>
    <div *ngIf="!loadProducts">
        <div  *ngFor="let product of products;let i=index">
            <product (OnPersonalize)="PersonalizeModal(i)" (OnAdd)="addElementToBasket(i)" [product]="product">
            </product>
        </div>
    </div>
    <div>
        <div class="alert alert-danger text-center" *ngIf="!loadProducts && family.id && products.length==0">
            Produit non disponible
            <ng-container *ngIf="chosenOrderType==1">en livraison</ng-container>
            <ng-container *ngIf="chosenOrderType==3">à emporter</ng-container>
            <ng-container *ngIf="chosenOrderType==2">sur place</ng-container>
        </div>
    </div>
</div>

